export default __webpack_public_path__ + "static/media/outbound.7f1baeef.svg";